// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","shadow":"Header_shadow__21OYT"};